<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    content: Object
});

const formattedDescription = computed(() => {
    return props.content.description ? props.content.description.replace(/\n/g, '<br>') : '';
});
</script>

<template>
    <p class="mt-3 text-sm text-slate-500 ltr:text-left rtl:text-right" v-html="formattedDescription"></p>
</template>


